<template>
  <v-card>
    <v-toolbar color="primary" dense dark flat>
      <v-toolbar-title>
        <span class="font-montserrat font-weight-bold">
          Reporte de autorizaciones de folios de redención
        </span>
      </v-toolbar-title>
    </v-toolbar>

    <v-card-text>
      <v-row>
        <v-col md="3">
          <v-radio-group v-model="modo" row>
            <v-radio label="Rango de fechas" value="rango" />
            <v-radio label="General" value="general" />
          </v-radio-group>

          <v-date-picker
            v-if="modo === 'rango'"
            v-model="dates"
            range
            :allowed-dates="validarFecha"
            locale="es"
          />

          <v-btn
            block
            color="primary"
            dark
            :loading="loading"
            :disabled="!puedeEjecutar"
            class="mt-4"
            @click="consultar"
          >
            Ejecutar Reporte
          </v-btn>

          <v-btn
            block
            class="mt-3"
            color="success"
            :loading="loading"
            :disabled=" logs.length === 0"
            @click="descargarCSV"
          >
            Descargar
          </v-btn>
        </v-col>

        <v-col md="9">
          <v-data-table
            :headers="columns"
            :items="logs"
            :page.sync="page"
            :items-per-page="size"
            :server-items-length="totalItems"
            :loading="loading"
            @update:page="onPageChange"
            @update:items-per-page="onItemsPerPageChange"
            class="elevation-1"
          />
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import moment from "moment";
import {
  getReporteLogsAutorizacion,
  getReporteAutoriazionFoliosCSV,
} from "@/services/reporteService.js";
export default {
  data() {
    return {
      modo: "rango",
      dates: [],
      logs: [],
      page: 1,
      size: 10,
      totalItems: 0,
      loading: false,
      hasExecutedQuery: false,
      columns: [
        { text: "Solicitud id", value: "solicitud_id" },
        { text: "Beneficio", value: "beneficio" },
        { text: "Fecha", value: "fecha" },
        { text: "Operador", value: "agente" },
      ],
    };
  },
  computed: {
    puedeEjecutar() {
      return (
        this.modo === "general" ||
        (this.modo === "rango" &&
          this.dates.length === 2 &&
          this.validarFecha(this.dates[0]))
      );
    },
    hasRange() {
      return this.dates.length === 2;
    },
  },
  watch: {
    modo() {
      this.dates = [];
      this.logs = [];
    },
  },
  methods: {
    validarFecha(fecha) {
      const fechaLimite = moment()
        .subtract(2, "months")
        .startOf("day");
      return moment(fecha).isSameOrAfter(fechaLimite);
    },

    onPageChange(newPage) {
      this.page = newPage;
      if (this.hasExecutedQuery) {
        this.fetchData();
      }
    },
    onItemsPerPageChange(newItemsPerPage) {
      this.size = newItemsPerPage;
      this.page = 1;
      if (this.hasExecutedQuery) {
        this.fetchData();
      }
    },
    async fetchData() {
      if (!this.puedeEjecutar) return;
      try {
        let fechas = [];
        if (this.modo === "rango" && this.dates.length === 2) {
          fechas = [
            moment.utc(this.dates[0]).format("YYYY-MM-DD"),
            moment.utc(this.dates[1]).format("YYYY-MM-DD"),
          ];
        }
        const filters = {
          fechas,
          limit: this.size,
          page: this.page - 1,
          order: "desc",
        };
        this.loading = true;
        const data = await getReporteLogsAutorizacion(filters);
        this.logs = data.data;
        this.totalItems = data.count;
      } catch (err) {
        console.error("Error al consultar reporte:", err);
      } finally {
        this.loading = false;
      }
    },
    async consultar() {
      this.page = 1;
      this.reportDownload = [];
      this.hasExecutedQuery = true;
      await this.fetchData();
    },
    descargarCSV() {
      try {
        const body = {};
        if (this.modo === "rango" && this.dates.length === 2) {
          const inicio = moment.utc(this.dates[0]).format("YYYY-MM-DD");
          const fin = moment
            .utc(this.dates[1])
            .add(24, "hours")
            .subtract(1, "seconds")
            .format("YYYY-MM-DD");
          body.fechas = [inicio, fin];
        }
        this.loading = true;
        getReporteAutoriazionFoliosCSV(body);
      } catch (err) {
        console.error("Error al consultar reporte:", err);
      } finally {
        this.loading = false;
      }
    },
  },
  mounted() {},
};
</script>
